import { DateRange } from '@creditsights/styleguide-web';
import { FILTER_RELATIVE_DATE_RANGE } from '@creditsights/styleguide-web/components/DateRange/DateRange.constants';
import { DateType } from '@creditsights/styleguide-web/components/DateRange/DateRange.types';
import React, { useCallback } from 'react';
import { FilterRendererProps } from '../../GroupedTableRow/GroupedTableRow.types';

interface DateRangePayload {
  startDate?: DateType;
  endDate?: DateType;
  relativeRange?: FILTER_RELATIVE_DATE_RANGE | null;
}

const DateFilterRenderer = <TData,>({
  onFilter,
  value,
}: FilterRendererProps<TData, DateRangePayload | undefined>): React.ReactElement => {
  const handleChange = useCallback(
    (payload: DateRangePayload) => {
      onFilter(payload);
    },
    [onFilter]
  );

  return (
    <DateRange
      startDate={value?.startDate || null}
      endDate={value?.endDate || null}
      onChange={handleChange}
      resetInput={0}
      error={false}
      relativeRange={value?.relativeRange ?? null}
      setError={() => {}}
    />
  );
};

export default DateFilterRenderer;
